import { NOT_KNOWN } from '../../converters/crmSearch/FilterCRMSearchOperatorTypesType';
import { QuickFiltersValueDisplayUses } from '../../types/quickFilters/QuickFiltersValueDisplayUses';
import FormattedMessage from 'I18n/components/FormattedMessage';
import QuickFiltersTags from './QuickFiltersTags';
import NotKnown from 'customer-data-filters-ui/filterQueryFormat/operator/NotKnown';
import { jsx as _jsx } from "react/jsx-runtime";
const QuickFiltersUnknownValueDisplay = props => {
  const {
    onValueDelete,
    condition,
    use
  } = props;
  const label = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "customerDataFiltersUI.quickFilters.unknown"
  });
  if (use === QuickFiltersValueDisplayUses.STRING) {
    return condition.constructor === NotKnown ? label : null;
  }
  const tags = condition.constructor === NotKnown ? [{
    value: NOT_KNOWN,
    label
  }] : [];
  return /*#__PURE__*/_jsx(QuickFiltersTags, {
    tags: tags,
    onTagClose: () => onValueDelete()
  });
};
export default QuickFiltersUnknownValueDisplay;